'use strict';
var ibmStickyHeader = (function () {
    function ibmStickyHeader($window) {
        this.$window = $window;
        this.restrict = 'A';
    }
    ibmStickyHeader.instance = function () {
        return new ibmParallaxScroll;
    };
    ibmStickyHeader.prototype.link = function (scope, element) {
        var windowEl = angular.element(this.$window);
        var body = angular.element(document).find('body');
        var b = element.height();
        var c = false;
        var handler = function () {
            var a = windowEl.scrollTop();
            if (a >= b) {
                if (c) {
                    return;
                }
                else {
                    body.addClass('ibm-sitenav-menu-sticky');
                    c = true;
                }
            }
            else {
                c = false;
                body.removeClass('ibm-sitenav-menu-sticky');
            }
        };
        windowEl.on('scroll', scope.$apply.bind(scope, handler));
        handler();
    };
    ibmStickyHeader.factory = function () {
        var directive = function ($window) { return new ibmStickyHeader($window); };
        directive.$inject = ['$window'];
        return directive;
    };
    return ibmStickyHeader;
}());
angular
    .module('application')
    .directive('ibmStickyHeader', function () { return ibmStickyHeader.factory(); });

//# sourceMappingURL=ibm-sticky-header.js.map
